
import { Button } from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

interface Villa {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
}

interface VillaCardProps {
  villa: Villa;
}

export function VillaCard({ villa }: VillaCardProps) {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate(`/contact?subject=${encodeURIComponent('Enquiry about ' + villa.name)}`);
  };

  const handleReadMore = () => {
    // Navigate to villa details page (can be implemented later)
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
      <div className="relative h-80">
        <img
          src={villa.image}
          alt={villa.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
      </div>

      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-3">
          {villa.name}
        </h3>

        <p className="text-gray-600 mb-4 leading-relaxed">
          {villa.description}
        </p>

        <button
          onClick={handleReadMore}
          className="text-emerald-600 hover:text-emerald-700 font-medium mb-4 cursor-pointer whitespace-nowrap"
        >
          Read More
        </button>

        <hr className="border-gray-200 mb-4" />

        <div className="flex items-center justify-between">
          <div>
            <span className="text-2xl font-bold text-gray-900">
              {villa.price}
            </span>
          </div>

          <Button
            onClick={handleBookNow}
            variant="primary"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 whitespace-nowrap cursor-pointer"
          >
            Book Now
          </Button>
        </div>
      </div>
    </div>
  );
}
